export default "__VITE_ASSET__D3iZZiF4__"